<template>
  <span>
    <v-card-title>
      Selecionar Vendedor
    </v-card-title>
    <v-card-text>
      Escolha o vendedor correspondente ao(s) pedido(s) selecionado(s):
      <div class="mt-3">
        <perfect-scrollbar class="fs-box-pedidos-selecionados">
          <span v-for="(pedido, index) in pedidosSelecionados" :key="index">
            ID: <b>{{ pedido.id.padStart(7, '0') }}</b> | Data: <b>{{ formatarData(pedido.created_at) }}</b> | Cliente: <b>{{ pedido.nome }}</b><br>
          </span>
        </perfect-scrollbar>
      </div>
      <v-select
        :items="vendedores"
        v-model="vendedorSelecionado"
        label="Selecionar Vendedor"
        item-text="nome"
        item-value="id"
        placeholder=" "
        class="mt-5"
        outlined
        dense
      ></v-select>

      <v-card-actions style="padding: 0px">
        <v-spacer></v-spacer>
        <v-btn color="#2A2F50" @click="selecionarVendedor()" dark small>
          <v-icon class="mr-1" style="font-size: 15px !important">mdi-checkbox-marked-circle-outline</v-icon>
          Selecionar
        </v-btn>
        <v-btn color="warning" @click="fecharDialog()" dark small>
          <v-icon class="mr-1" style="font-size: 15px !important">mdi-close</v-icon>
          Fechar
        </v-btn>
      </v-card-actions>
    </v-card-text>
  </span>
</template>

<script>
import { mapState, mapMutations, mapActions } from 'vuex'
import { updateVendedorCarrinhos } from '@/api/carrinho'
import { list } from '@/api/crud'
import moment from 'moment'
export default {
  props: {
    fecharDialog: Function
  },
  data () {
    return {
      vendedores: [],
      vendedorSelecionado: null
    }
  },
  async mounted () {
    this.vendedores = await list('/admin/vendedores')
  },
  computed: {
    ...mapState({
      pedidosSelecionados: state => state.pedidos.pedidosSelecionados,
      pedidos: state => state.pedidos.pedidos
    })
  },
  methods: {
    ...mapActions({
      loadPedidos: 'pedidos/loadPedidos'
    }),
    ...mapMutations({
      setSnackbar: 'global/setSnackbar'
    }),
    formatarData (data) {
      return moment(data).format('L LT')
    },
    async selecionarVendedor () {
      this.$store.state.pedidos.loading = true
      if (this.vendedorSelecionado) {
        const obj = []
        this.pedidosSelecionados.map(pedido => {
          obj.push({ id: pedido.id, vendedor_id: this.vendedorSelecionado })
        })
        try {
          this.fecharDialog()
          await updateVendedorCarrinhos(obj)
          await this.loadPedidos({ page: this.pedidos.page, limit: this.pedidos.perPage })
          this.setSnackbar({ msg: 'Pedido(s) atualizado(s) com sucesso!', color: 'green' })
        } catch (error) {
          this.setSnackbar({ msg: `Ocorreu um erro ao atualizar o(s) pedido(s).  ${error}` })
        }
      } else {
        this.setSnackbar({ msg: 'Selecione um vendedor para atribuir ao(s) pedido(s) selecionado(s)', color: '#FB8C00' })
      }
      this.$store.state.pedidos.loading = false
    }
  }
}
</script>

<style scoped>
  .fs-box-pedidos-selecionados {
    height: 100%;
    max-height: 105px;
    border: 1px solid #CCC;
    border-radius: 5px;
    padding: 5px;
    padding-left: 10px;
  }
</style>
